import Typography from "@material-ui/core/Typography";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getPublicPrice } from "../../utils/weightUtils";
import ProductAddToBasket from "../products/ProductAddToBasket";
import "./infoScreen.scss";

function ProductInfo(props) {
	let productId = null;
	const location = useLocation();
	if (location.state) {
		const { from } = location.state;
		productId = from;
	}

	const [productInfo, setproductInfo] = useState(null);

	async function getProductInfo(id) {
		if (props.loginSuccesful) {
			await axios
				.post("/productpage", {
					marketplace: props.identifyInfo.marketplace,
					key: props.identifyInfo.key,
					product_id: id,
				})
				.then((response) => {
					setproductInfo(response.data.data.product);
				});
		} else {
			await axios
				.post("/public_product", {
					marketplace: props.identifyInfo.marketplace,
					key: props.identifyInfo.key,
					product_id: id,
				})
				.then((response) => {
					setproductInfo(response.data.data.product);
				});
		}
	}

	useEffect(() => {
		if (productId) {
			getProductInfo(productId);
		}
	}, [location.state]);

	return productInfo ? (
		<div className="centerDiv">
			{productInfo.image ? (
				<img className="supplierPhoto" src={productInfo.image}></img>
			) : null}
			<br />
			<p1 style={{ color: "grey", fontWeight: "bold" }}>
				{productInfo.main_group_name}
			</p1>
			<br />
			{productInfo.bio ? (
				<div>
					<p className="productName">{productInfo.name}</p>{" "}
					<img
						className="bio"
						src={
							"https://www.goeieete.nl/wp-content/themes/goeieete/assets/logo-bio.svg"
						}
					/>
				</div>
			) : (
				<p className="productName">{productInfo.name}</p>
			)}
			<Link
				style={{ textDecoration: "none" }}
				to={{
					pathname: "/supplierinfo",
					state: { from: productInfo.supplier_id },
				}}
			>
				<p1 className="supplierName">{productInfo.supplier}</p1>
				<br />
			</Link>
			<br />
			<Typography
				component="span"
				variant="body2"
				className="inline"
				color="textPrimary"
			>
				{getPublicPrice(productInfo)}
			</Typography>
			<br />
			<div
				style={{ textAlign: "left" }}
				dangerouslySetInnerHTML={{ __html: productInfo.description }}
			></div>
			{props.loginSuccesful ? (
				<div className="AddBasketButtonProductInfo">
					<ProductAddToBasket
						productId={productInfo.id}
						rowData={productInfo}
						screenType="Assortiment"
					/>
				</div>
			) : null}
		</div>
	) : (
		<p1>Kies eerst een product waarover u meer informatie wilt.</p1>
	);
}

function mapStateToProps(state) {
	return {
		identifyInfo: state.identify.identifyInfo,
		loginSuccesful: state.login.data.loginSuccesful,
	};
}

export default connect(mapStateToProps)(ProductInfo);
